export default "__VITE_ASSET__d32ac7f0__"